import { PropsWithChildren } from 'react';

import { cn } from '@utils';

interface CardProps {
  className?: string;
  onClick?: () => void;
  rounded?: string;
  withoutPadding?: boolean;
}

export const Cards = ({
  children,
  className = '',
  withoutPadding = false,
  rounded = 'rounded-md',
  onClick,
}: PropsWithChildren<CardProps>) => {
  const dynamicClasses = cn('shadow-card bg-white bg-opacity-90', !withoutPadding && 'p-6', rounded, className);

  return (
    <div className={dynamicClasses} onClick={onClick}>
      {children}
    </div>
  );
};
